"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Notifier = {
    sweetAlert: function () {
        if (typeof window[AppSettings.sweetalert_signature] !== 'undefined') {
            Swal.fire(window[AppSettings.sweetalert_signature]);
        }
    },
    toaster: function () {
        if (typeof window[AppSettings.toaster_signature] !== 'undefined') {
            const toasterData = window[AppSettings.toaster_signature];
            toastr.options = toasterData.options;
            toasterData.notifications.map((notification) => {
                toastr[notification.type](notification.message, notification.title, JSON.parse(notification.options));
            });
        }
    }
};
exports.default = Notifier;
